module.exports = __webpack_public_path__ + "img/24.4906c8b0.png";